export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';

export const GET_USERS_BY_URL_REQUEST = 'GET_USERS_BY_URL_REQUEST';
export const GET_USERS_BY_URL_SUCCESS = 'GET_USERS_BY_URL_SUCCESS';
export const GET_USERS_BY_URL_FAILED = 'GET_USERS_BY_URL_FAILED';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILED = 'GET_USER_FAILED';

export const ANONYMIZE_USER_REQUEST = 'ANONYMIZE_USER_REQUEST';
export const ANONYMIZE_USER_SUCCESS = 'ANONYMIZE_USER_SUCCESS';
export const ANONYMIZE_USER_FAILED = 'ANONYMIZE_USER_FAILED';

export const GET_ANONYMIZATION_REQUEST = 'GET_ANONYMIZATION_REQUEST';
export const GET_ANONYMIZATION_SUCCESS = 'GET_ANONYMIZATION_SUCCESS';
export const GET_ANONYMIZATION_FAILED = 'GET_ANONYMIZATION_FAILED';

export const GET_DEACTIVATION_REQUEST = 'GET_DEACTIVATION_REQUEST';
export const GET_DEACTIVATION_SUCCESS = 'GET_DEACTIVATION_SUCCESS';
export const GET_DEACTIVATION_FAILED = 'GET_DEACTIVATION_FAILED';

export const DEACTIVATE_USER_REQUEST = 'DEACTIVATE_USER_REQUEST';
export const DEACTIVATE_USER_SUCCESS = 'DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_FAILED = 'DEACTIVATE_USER_FAILED';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

export const GET_USER_ACTIVITIES_REQUEST = 'GET_USER_ACTIVITIES_REQUEST';
export const GET_USER_ACTIVITIES_SUCCESS = 'GET_USER_ACTIVITIES_SUCCESS';
export const GET_USER_ACTIVITIES_FAILED = 'GET_USER_ACTIVITIES_FAILED';

export const GET_USER_ACTIVITY_REQUEST = 'GET_USER_ACTIVITY_REQUEST';
export const GET_USER_ACTIVITY_SUCCESS = 'GET_USER_ACTIVITY_SUCCESS';
export const GET_USER_ACTIVITY_FAILED = 'GET_USER_ACTIVITY_FAILED';

export const GET_USER_ACTIVITIES_BY_URL_REQUEST = 'GET_USER_ACTIVITIES_BY_URL_REQUEST';
export const GET_USER_ACTIVITIES_BY_URL_SUCCESS = 'GET_USER_ACTIVITIES_BY_URL_SUCCESS';
export const GET_USER_ACTIVITIES_BY_URL_FAILED = 'GET_USER_ACTIVITIES_BY_URL_FAILED';

export const GET_LOYALTY_STATISTICS_REQUEST = 'GET_LOYALTY_STATISTICS_REQUEST';
export const GET_LOYALTY_STATISTICS_SUCCESS = 'GET_LOYALTY_STATISTICS_SUCCESS';
export const GET_LOYALTY_STATISTICS_FAILED = 'GET_LOYALTY_STATISTICS_FAILED';

export const CHANGE_USER_PERMISSIONS_REQUEST = 'CHANGE_USER_PERMISSIONS_REQUEST';
export const CHANGE_USER_PERMISSIONS_SUCCESS = 'CHANGE_USER_PERMISSIONS_SUCCESS';
export const CHANGE_USER_PERMISSIONS_FAILED = 'CHANGE_USER_PERMISSIONS_FAILED';

export const AUTHENTICATE_AS_USER_REQUEST = 'AUTHENTICATE_AS_USER_REQUEST';
export const AUTHENTICATE_AS_USER_SUCCESS = 'AUTHENTICATE_AS_USER_SUCCESS';
export const AUTHENTICATE_AS_USER_FAILED = 'AUTHENTICATE_AS_USER_FAILED';

export const GET_USER_GROUPS_REQUEST = 'GET_USER_GROUPS_REQUEST';
export const GET_USER_GROUPS_SUCCESS = 'GET_USER_GROUPS_SUCCESS';
export const GET_USER_GROUPS_FAILED = 'GET_USER_GROUPS_FAILED';

export const GET_APPLICATION_SUBSCRIPTION_REQUEST = 'GET_APPLICATION_SUBSCRIPTION_REQUEST';
export const GET_APPLICATION_SUBSCRIPTION_SUCCESS = 'GET_APPLICATION_SUBSCRIPTION_SUCCESS';
export const GET_APPLICATION_SUBSCRIPTION_FAILED = 'GET_APPLICATION_SUBSCRIPTION_FAILED';

export const SET_ACTIVE_USER = 'SET_ACTIVE_USER';

export const SET_ACTIVE_USER_INFO = 'SET_ACTIVE_USER_INFO';

export const SET_USER_HAS_VALID_ADDRESS = 'SET_USER_HAS_VALID_ADDRESS';
export const SET_USER_HAS_BEEN_VALIDATED = 'SET_USER_HAS_BEEN_VALIDATED';
export const CLEAR_USER_ATTRIBUTES = 'CLEAR_USER_ATTRIBUTES';

export const GET_STATES_REQUEST = 'GET_STATES_REQUEST';
export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES_FAILED = 'GET_STATES_FAILED';

export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILED = 'GET_COUNTRIES_FAILED';

export const GET_COMMUNICATION_REQUEST = 'GET_COMMUNICATION_REQUEST';
export const GET_COMMUNICATION_SUCCESS = 'GET_COMMUNICATION_SUCCESS';
export const GET_COMMUNICATION_FAILED = 'GET_COMMUNICATION_FAILED';

export const SAVE_COMMUNICATION_REQUEST = 'SAVE_COMMUNICATION_REQUEST';
export const SAVE_COMMUNICATION_SUCCESS = 'SAVE_COMMUNICATION_SUCCESS';
export const SAVE_COMMUNICATION_FAILED = 'SAVE_COMMUNICATION_FAILED';

export const CLEAR_ANONYMIZATION = 'CLEAR_ANONYMIZATION';
export const CLEAR_DEACTIVATION = 'CLEAR_DEACTIVATION';
export const CLEAR_MERGE = 'CLEAR_MERGE';

export const GET_MERGE_REQUEST = 'GET_MERGE_REQUEST';
export const GET_MERGE_SUCCESS = 'GET_MERGE_SUCCESS';
export const GET_MERGE_FAILED = 'GET_MERGE_FAILED';

export const MERGE_USER_REQUEST = 'MERGE_USER_REQUEST';
export const MERGE_USER_SUCCESS = 'MERGE_USER_SUCCESS';
export const MERGE_USER_FAILED = 'MERGE_USER_FAILED';